import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import rou from '../../router';

const useCheckingCtrl = () => {
  const [ctrl, setCtrl] = useState(false);
  const location = useLocation();

  const openRou = [
    rou.bedstatusRou.path,
    rou.bedstatusNewRou.path,
    rou.admissionRou.path,
    rou.admissionActionableRou.path,
  ];

  const isPathMatched = (item) => {
    const re = new RegExp(`^${item}`);

    return re.test(location?.pathname);
  };

  useEffect(() => {
    const checked = _.some(openRou, (item) => isPathMatched(item));

    if (checked) {
      const timeout = setTimeout(() => {
        setCtrl(true);
      }, 60 * 1000);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      setCtrl(false);
    }
  }, [location?.pathname]);

  return ctrl;
};

export default useCheckingCtrl;
